<template>
  <div id="app">
    <headertop></headertop>
    <div class="main">
      <!-- 面包屑-->
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-if="play.type==0" :to="{ path: '/opencourses?type=0' }">药知课程</el-breadcrumb-item>
        <el-breadcrumb-item v-else :to="{ path: '/opencourses?type=1' }">内部课程</el-breadcrumb-item>
        <el-breadcrumb-item v-for="(val,key) in play.info.address" :key="key">
          <span v-if="val.number && val.number!=0">[{{val.number}}]</span>{{val.name}}
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{play.info.name}}</el-breadcrumb-item>
      </el-breadcrumb>
      <div style="padding: 20px;">
        <!-- 视频-->
        <el-form class="videoplay left" ref="video">
          <el-form-item prop="video" style="width: 100%">
            <div class="whole">
              <div class="player-div">
              <div class="jiyi" v-show="jiyidian">
                <span @click='quick' style="cursor: pointer;">跳转到上次播放的位置</span>
                <i class="el-icon-close" style="color: white;" @click="jiyidian=false"></i></div>
                <video ref="videoPlayer" class="video-js video vjs-big-play-centered" controlslist="nodownload noremoteplayback" oncontextmenu = "return false">
                </video>
                <div class="player-barrage">
                	<ul class="roll"></ul>
                	<ul class="center"></ul>
                </div>
              </div>
              <el-button size="mini" class="btn-s" ref="btns" @click="hide"><i class="el-icon-arrow-left"></i>
              </el-button>
            </div>
          </el-form-item>
          <div class="below-div">
            <div @click="change_time('del')">-15S</div>
            <div @click="change_time('add')">+15S</div>
            <div @click="button_c('dz')" v-if="dz_button=='1'">已赞</div>
            <div @click="button_c('dz')" v-else>点赞</div>
            <div @click="button_c('sc')" v-if="sc_button=='1'">已收藏</div>
            <div @click="button_c('sc')" v-else>收藏</div>
            <div @click="right_show('first')">章节</div>
            <div @click="right_show('tigang')" v-if="play.type=='0'">知识点</div>
            <div @click="right_show('second')">笔记</div>
            <div @click="right_show('third')">提问</div>
            <div @click="right_show('sign')">标记</div>
            <div @click="button_c('kj')"  v-if="file!=0" style="	position: absolute;	right: 0;">课件</div>
          </div>
        </el-form>
        <!-- 侧边栏 -->
        <div class="videocard right">
          <el-button size="mini" class="btn-h" ref="btnh" @click="hide"><i class="el-icon-arrow-right"></i></el-button>
          <!-- 课程列表 -->
          <el-tabs class="box-card " v-model="activeName" type="card" @tab-click="handleClick" ref="card">
            <el-tab-pane label="章节" name="first">
              <div v-for="(val,key) in play.list" :key="key" style="cursor: pointer;" @click="change_play(val.num)">
                <div v-if="val.num==play.num" class="item itemhover itemactive">
                  <img src="../../../assets/playon.gif" style="height: 12px" />{{val.name}}
                </div>
                <div v-else class="item">
                  {{val.name}}
                </div>
              </div>
            </el-tab-pane>
            <!-- 题纲-->
            <el-tab-pane label="知识点" name="tigang" v-if="play.type=='0'">
              <div class="tigang" style="overflow: auto; height: 100%;">
                <div v-for="(item,index) in yaodian.list" :key="index" style="cursor: pointer;"  @click="sign_time('yaodian',item,index)">
                  <div  class="item">
                    {{item.content}}
                  </div>
                </div>
              </div>

            </el-tab-pane>
            <!-- 笔记-->
            <el-tab-pane label="笔记" name="second">
              <div class="notes">
                <div v-for="(val,key) in play.note" :key="key" class="con">
                  {{val.content}}
                  <p>{{val.time}}</p>
                </div>
              </div>
              <div class="add">
                <div class="newnote" v-if="add.addnote">
                  <el-input v-model="add.note" placeholder="请输入笔记" type="textarea"></el-input>
                  <el-button class="left" size="mini" type="info" @click="add_btn('note')" plain>取消</el-button>
                  <el-button class="right" size="mini" type="success" plain @click="save_btn('note')">保存</el-button>
                </div>
                <el-button size="small" @click="add_btn('note')" ref="notebtn" class="addbtn">添加笔记</el-button>
              </div>
            </el-tab-pane>
            <!-- 提问-->
            <el-tab-pane label="提问" name="third">
              <div class="notes">
                <div v-for="(val,key) in play.question" :key="key" class="con">
                  {{val.content}}
                  <p>{{val.time}}</p>
                </div>
              </div>
              <div class="add">
                <div class="newnote" v-if="add.addqes">
                  <el-input v-model="add.qes" placeholder="请输入问题" type="textarea"></el-input>
                  <el-button class="left" size="mini" type="info" @click="add_btn('qes')" plain>取消</el-button>
                  <el-button class="right" size="mini" type="success" plain @click="save_btn('qes')">保存</el-button>
                </div>
                <el-button size="small" @click="add_btn('qes')" ref="qesbtn" class="addbtn">添加问题</el-button>
              </div>
            </el-tab-pane>

            <!--标记-->
            <el-tab-pane label="标记" name="sign">
              <div class="sign" style="overflow: auto; height: 100%;">
                <div id="sign-time-line" >
                  <div class="sign-item" v-for="(item,index) in sign.list" :key="index">
                    <div class="sign-item-index" @click="sign_time('sign',item,index)">{{ item.times }}</div>
                    <div class="sign-item-content" @click="sign_time('sign',item,index)">{{ item.content }}</div>
                    <div>
                      <span style="cursor: pointer;font-size: 10px;" @click="sign_up(item)">编辑</span>
                      <span style="cursor: pointer;color: red;font-size: 10px;" @click="sign_del(item)">删除</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="add">
                <div class="newnote" v-if="add.addsign">
                  <el-input v-model="add.sign" placeholder="请输入内容" type="textarea"></el-input>
                  <el-button class="left" size="mini" type="info" @click="add_btn_s('sign')"  plain>取消</el-button>
                  <el-button class="right" size="mini" type="success" plain @click="sign_btn()">保存</el-button>
                </div>
                <el-button size="small" @click="add_btn('sign')" ref="signbtn" class="addbtn">添加标记</el-button>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>

    </div>
    <footerbom></footerbom>
    <el-dialog v-el-drag-dialog :visible.sync="courseware.show" title="课件" :close-on-click-modal="true" style="">
        <iframe :src="file" frameborder="0" style="width:100%;" :height="height"></iframe>
    </el-dialog>
  </div>
</template>

<script>
    import Header from '../../../components/index/public/visitor_NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  import elDragDialog from "../../../components/index/el-drag-dialog/drag.js";
  export default {
    name: 'App',
    data() {
      return {
        sign:{
          list:[],
          num:-1,
          up_num:''
        },
        yaodian:{
          list:[]
        },
        courseware:{//课件
          show:false
        },
        dz_button:null,
        sc_button:null,
        jiyidian:false,
        play:{
          type:this.$route.query.type,
          num:this.$route.query.num,
          resource:this.$route.query.resource,
          info:{},
          list:[],
          note:[],
          status:false,
          old_time:0
          // name:''
        },
        activeName: 'first',
        player: null,
        videoOptions: {
          lang: 'zh-CN',
          autoplay: true,//自动播放
          controls: true,//用户可以与之交互的控件
          loop:false,//视频一结束就重新开始
          muted:false,//默认情况下将使所有音频静音
          // aspectRatio:"16:9",//显示比率
          // preload:false,//预加载
          notSupportedMessage: '此视频暂无法播放，请稍后再试',
          errorDisplay: false,
          fluid: true,
          controlBar: {
            playToggle:true,
            volumePanel:true,
            currentTimeDisplay:true,
            progressControl:false,
          },
          sources:[{
            src: "",
            type: ""
          }],
        },
        add:{
          type:'',
          addnote:false,
          note:'',
          addqes:false,
          qes:'',
          addsign:false,
          sign:'',
          sign_time:0
        },
        study_time_status:null,
        height:0,
        chat:{
          rollBarrageIndex: 0,		//用来固定位置的
        }
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer,
    },
    directives: { elDragDialog },
    mounted:function(){
      this.change_height()
      this.get_list()
      this.$refs.videoPlayer.addEventListener('timeupdate',this.check_study_time)
      this.$refs.videoPlayer.addEventListener('pause',this.clear_study_time_status)
      this.$refs.videoPlayer.addEventListener('ended',this.play_end)
      this.$refs.videoPlayer.addEventListener('waiting',this.clear_study_time_status)
      this.$refs.videoPlayer.addEventListener('dispose',this.clear_study_time_status)
      this.$refs.videoPlayer.addEventListener('error',this.clear_study_time_status)
      this.hide()
      this.right_show('first')
    },

    destroyed:function(){
      this.save_study_time()
    },

    methods: {
      add_btn_s(){
        this.add_btn('sign')
        this.sign.up_num=''
      },
      sign_time(type,item,index){
        if(type=='sign'){
          this.sign.num=index
          this.player.currentTime(item.time)
        }else{
          this.player.currentTime(item.time)
        }

      },
      sign_up(item){
        this.sign.up_num=''
        this.sign.up_num=item.num
        this.sign.up_time=item.times
        this.add_btn('sign')
        this.add.sign=item.content

      },
      sign_del(item){
        let _this=this
        _this.axios.post('/v2/user/video_sign_del',{data:item.num}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.get_video_sign()
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      sign_btn(){
        let _this=this
        if(_this.sign.up_num!=''){
          let temp= _this.sign.up_time.split(':')
          temp=parseInt(temp[0]*3600)+parseInt(temp[1]*60)+parseInt(temp[2])
         _this.add.sign_time=temp
        }

        var data={
          'content':_this.add.sign,
          'type':_this.play.type,
          'video':_this.play.num,
          'time':_this.add.sign_time,
          'num':_this.sign.up_num,
        }

        if(data.content==''){
          _this.$message.error('请输入标记内容')
          return false
        }
        _this.axios.post('/v2/user/save_video_sign',{data:data}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.get_video_sign()
              _this.$message.success(res.data.msg)
              _this.add.sign=''
              _this.sign.up_num=''
              _this.add_btn('sign')
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      play_end(){
        let _this=this
        _this.clear_study_time_status
        for(var i=0;i<_this.play.list.length;i++){
          if(_this.play.list[i].num==_this.play.num){
            if(i<_this.play.list.length-1){
              _this.change_play(_this.play.list[i+1].num)
            }else{
              _this.change_play(_this.play.list[0].num)
            }
            return
          }
        }
      },
      //点赞收藏事件
      button_c(type){
        let _this=this
        if(type=="dz"){
          _this.support('support','dz_button')
        }else if(type=="sc"){
          _this.support('collect','sc_button')
        }else{
          // _this.courseware.show=true
          window.open('/video_file?file='+_this.file,'_blank')
        }
      },
      support(opration,button){
        let _this=this
        _this.axios.post('/v2/user_resource/resource_support',{data:{resource_type:'video',type:_this.play.type,num:_this.play.num,opration:opration}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              if(opration=='support'){
                _this.dz_button=res.data.data
              }else{
                _this.sc_button=res.data.data
              }
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      quick(){
        let _this=this
        _this.jiyidian=false
        if(_this.play.info.quick_time!=0 && _this.player){
          _this.player.currentTime(_this.play.info.quick_time)
        }
      },
      change_time(type){
        let _this=this
        if(type=='add'){
          _this.player.currentTime(_this.player.currentTime()+15)
        }else{
          _this.player.currentTime(_this.player.currentTime()-15)
        }
      },
      get_list(){
        let _this=this
        _this.axios.get('/v2/user_resource/get_list',{params:{type:_this.play.type,num:_this.play.num,resource:_this.play.resource}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.play.list=res.data.data
              if(_this.play.resource=='l'){
                _this.play.num=res.data.data[0].num
              }
              _this.get_system()
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      get_system(){
        let _this=this
        _this.axios.get('/v2/user_resource/get_system').then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              if(res.data.data.video_percentage=='1'){
                _this.videoOptions.controlBar.progressControl=true//倍数
              }
              if(res.data.data.video_multiple=='1'){
                _this.videoOptions.playbackRates=[0.5,1,1.25,1.5,1.75,2,3]//倍数
              }
              _this.get_info('v')
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        })
      },
      get_info(resource){
        let _this=this
        _this.play.status=false
        _this.axios.get('/v2/user_resource/get_info',{params:{type:_this.play.type,num:_this.play.num,resource:resource}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.play.info=res.data.data
              _this.play.num=res.data.data.num
              _this.dz_button=res.data.data.support
              _this.sc_button=res.data.data.collect
              _this.file=res.data.data.file
              _this.videoOptions.sources[0].type=res.data.data.type
              _this.play.status=true
              if(res.data.data.quick_time!=0){
                _this.jiyidian=true
              }
              _this.get_note()
              _this.get_question()
              _this.get_video_sign()
              _this.get_video_yaodian()
              _this.watch()
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      get_note(){
        let _this=this
        _this.axios.get('/v2/user_resource/get_note',{params:{type:_this.play.type,num:_this.play.num}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.play.note=res.data.data
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      get_question(){
        let _this=this
        _this.axios.get('/v2/user_resource/get_question',{params:{type:_this.play.type,num:_this.play.num}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.play.question=res.data.data
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      get_video_sign(){
        let _this=this
        let time=''
        _this.axios.get('/v2/user/get_video_sign',{params:{type:_this.play.type,video:_this.play.num}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.sign.list=res.data.data
              for(let i=0;i<_this.sign.list.length;i++){
              time= _this.getHMS(_this.sign.list[i].time)
              _this.sign.list[i]['times']=time

              }
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      get_video_yaodian(){
        let _this=this
        let time=''
        _this.axios.get('/v2/user/get_video_yaodian',{params:{type:_this.play.type,video:_this.play.num}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.yaodian.list=res.data.data
              for(let i=0;i<_this.yaodian.list.length;i++){
              time= _this.getHMS(_this.yaodian.list[i].time)
              _this.yaodian.list[i]['times']=time
              }
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      // 根据秒数转换成对应的时分秒
      getHMS(time) {
        const hour = parseInt(time / 3600) < 10 ? '0' + parseInt(time / 3600) : parseInt(time / 3600)
        const min = parseInt(time % 3600 / 60) < 10 ? '0' + parseInt(time % 3600 / 60) : parseInt(time % 3600 / 60)
        const sec = parseInt(time % 3600 % 60) < 10 ? '0' + parseInt(time % 3600 % 60) : parseInt(time % 3600 % 60)
        return hour + ':' + min + ':' + sec
        // console.log(hour + ':' + min + ':' + sec)
      },
      change_play(num){
        let _this=this
        if(num==_this.play.num){
          return false
        }
        _this.play.num=num
        _this.get_info('v')
      },
      watch() {
        let _this=this
        _this.videoOptions.sources[0].src='/v2/user_resource/play?key='+localStorage.authorization+'&type='+_this.play.type+'&num='+_this.play.num
        _this.start_player()
      },
      start_player(){
        let _this=this
        if(_this.player){
          _this.player.src({type:_this.videoOptions.sources[0].type, src:_this.videoOptions.sources[0].src})
          _this.player.load()
        }else{
          _this.$nextTick(()=>{
            _this.player = _this.$video(_this.$refs.videoPlayer, _this.videoOptions, function onPlayerReady() {
            })
          })
        }
      },

      check_study_time(){
        let _this=this
        if(_this.player.currentTime()==_this.play.old_time){
            clearInterval(_this.study_time_status)
            _this.study_time_status=null
        }else{
          _this.play.old_time=_this.player.currentTime()
          if(_this.study_time_status==null){
            _this.study_time_status=setInterval(()=>{
              _this.save_study_time()
            },5000)
          }
        }
      },

      clear_study_time_status(){
        clearInterval(this.study_time_status)
        this.study_time_status=null
      },

      save_study_time(){
        let _this=this
        let data={
          type:_this.play.type,
          num:_this.play.num,
          time:5,
          progress:(parseInt(_this.player.currentTime())/_this.player.duration()* 100).toFixed(0),
          play_time:parseInt(_this.player.currentTime())
        }
        _this.axios.post('/v2/user_resource/save_study_time',{data:data}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code!='1'){
              _this.$message({ type:'warning', message:res.data.msg,duration: 3000} );
            }
          }
        }).catch(function(error) {
          // _this.$message.error('服务器内部错误')
        });
      },

      save_btn(type){
        let _this=this
        if(!_this.play.status){
          return false
        }
        _this.axios.post('/v2/user/save_note_question',{data:{num:_this.play.num,type:_this.play.type,content:_this.add[type],content_type:type}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.add[type]=''
              _this.get_note()
              _this.get_question()
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      handleClick(tab, event) {

      },
      add_btn(type){
        let _this=this
        if(!_this.play.status){
          return false
        }
        _this.add.type=type
        if(_this.add['add'+type]){
          _this.add['add'+type] = false;
          _this.$refs[type+'btn'].$el.style.display = 'inline'
        }else{
          _this.add['add'+type] = true;
          _this.$refs[type+'btn'].$el.style.display = 'none'
        }
        if(type=='sign'){
          _this.add.sign_time=_this.player.currentTime()
          _this.add.sign=''
        }
      },
      //侧边栏
      hide() {
        let _this = this
        //获取视频宽度
        let video = _this.$refs.video.$el.clientWidth;
        let videof = _this.$refs.video.$el.parentElement.clientWidth;
        if (_this.$refs.card.$el.style.display == '') {
          //隐藏
          _this.$refs.btns.$el.style.display = 'inline'
          _this.$refs.btnh.$el.style.display = 'none'
          _this.$refs.card.$el.style.display = 'none'
          _this.$refs.video.$el.style.width = videof - 40 + 'px'
        } else {
          //显示
          _this.$refs.btnh.$el.style.display = 'inline'
          _this.$refs.btns.$el.style.display = 'none'
          _this.$refs.card.$el.style.display = ''
          _this.$refs.video.$el.style.width = '75%'
        }
        _this.change_height()
      },

      right_show(type){
        let _this=this
        _this.$refs.btnh.$el.style.display = 'inline'
        _this.$refs.btns.$el.style.display = 'none'
        _this.$refs.card.$el.style.display = ''
        _this.$refs.video.$el.style.width = '75%'
        _this.change_height()
        _this.activeName=type

      },

      //视频与侧边栏高度
      change_height() {
        let _this = this
        let video = _this.$refs.video.$el.offsetHeight
        let card = _this.$refs.card.$el.offsetHeight
        let btnh = _this.$refs.btnh.$el.offsetHeight
        let btns = _this.$refs.btns.$el.offsetHeight
        let btntoph = video - btnh
        let btntops = video - btns
        _this.$refs.card.$el.style.height = video + 'px'
        _this.$refs.btnh.$el.style.top = btntoph / 2 + 'px'
        _this.$refs.btns.$el.style.top = btntops / 2 + 'px'
        _this.height=(window.innerHeight-100)+'px'
      }
    }
  }
</script>

<style scoped>
  .sign-item {
    margin-left: 30px; /*用左边margin显示时间线*/
    width: calc(100% - 30px); /*因为左边部分用于显示时间线，所以右边部分减去30px*/
    height: auto; /*高度由内容决定*/
    position: relative;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .sign-item::before {
    content: "";
    width: 11px;
    height: 11px;
    border-radius: 100%;
    background-color: #91c2fc;
    position: absolute;
    left: -15px;
  }
  .sign-item::after {
      content: "";
      width: 3px;
      height: calc(100% + 10px); /*加上10px是item底部的margin*/
      background-color: #91c2fc;
      position: absolute;
      top: 0;
      left: -11px;
  }
  .sign-item-index {
    line-height: 12px;
    font-size: 12px;
    position: relative;
    color: #656565;
  }
  .sign-item-content {
    width: 100%;
    height: auto; /*由内容决定*/
    position: relative;
    white-space: pre-wrap; /*保留空白符序列，但是正常地进行换行*/
    word-wrap: break-word; /*在长单词或 URL 地址内部进行换行*/
  }
  .sign-item:hover::before {
    transform: scale3d(1.2, 1.2, 1);
    background-color: #569ffb;
  }

  .sign-item:hover::after {
    transform: scale3d(1.1, 1, 1);
    background-color: #569ffb;
  }

  .sign-item:hover .item-index{
    transform: scale3d(1.01, 1.01, 1);
    color: #343434;
  }
  .jiyi{
    z-index:100;
    position: absolute;
    right:1rem;
    bottom: 2rem;
    background-color: rgb(80, 79, 77);
    opacity:0.7;
    color: #00F5FF;
    padding: 0 0.5rem;
    border-radius: 0.3rem;
  }
  .below-div div{
      color: white;
      height: 100%;
      width: 50px;
      float: left;
      background-color: rgb(80, 79, 77);
      border: none;
      margin-left: 10px;
      cursor: pointer;
      display: flex;
      align-items: center; /*定义body的元素垂直居中*/
      justify-content: center; /*定义body的里的元素水平居中*/

        }
  /*点赞收藏*/
  .below-div{
    display:inline-block;
      width: 100%;
      height: 40px;
      background-color: rgb(80, 79, 77);
      position:relative;
      color: white;

  }
  .main {
    min-height: calc(100vh - 330px);
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
    overflow: hidden;
  }

  h1 {
    margin: 20px;
  }

  /* 视频播放 */
  .videoplay {
    max-width: 100%;
    width: 75%;
  }

  .video {
    display: block;
    height: 100%;
    position: absolute;
  }

  .whole {
    padding-bottom: 56.25%;
    height: 0;
    position: relative;
  }

  .el-form-item {
    padding: 0;
    margin: 0;
  }

  .el-form-item,
  .el-form-item__content,
  .whole,
  .video {
    width: 100%;
  }

  /* 侧边栏*/

  >>>.el-tabs__content {
    margin: 15px 20px;

  }

  .item {
    padding: 9px;
  }
.itemactive{
  color: #008000 ;
  background-color: rgba(231, 245, 255, 0.6) !important ;
}
.item:hover{
  color: #008000 ;
  background-color: rgba(231, 245, 255,0.3) ;
}
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both;
  }

  .videocard {
    width: calc(25% - 1px);
    position: relative;
  }

  .box-card {
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / 12%), 0 0 6px 0 rgb(0 0 0 / 4%);
    border: 1px solid #DCDFE6;
    border-left: 0;
    border-top: 0;
    border-radius: 0px 5px 5px 0px;
  }

  .btn-h {
    position: absolute;
    left: 0;
    top: 0;
    padding: 20px 2px;
    border-left: 0;
    border-radius: 0px 5px 5px 0px;
    background-color: rgb(0 0 0 / 12%);
  }

  .btn-s {
    display: none;
    position: absolute;
    right: 0;
    top: 0;
    padding: 20px 2px;
    border-right: 0;
    border-radius: 5px 0px 0px 5px;
    background-color: rgb(255 255 255 / 52%);
  }

  .el-tab-pane {
    height:  calc(100% - 71px);
  }

  /* 笔记*/
  .con{
    margin: 15px 0;
  }
  .con > p {
    font-size: smaller;
    color: lightgray;
    margin: 2px 0;
  }
  .notes {
    height: 95%;
    overflow: auto;
  }

  .newnote {
    overflow: hidden;
  }

  .add {
    width: 100%;
    position: absolute;
    bottom: 0;
  }

  .addbtn {
    width: 100%;
    margin: 25px 0;
  }

  >>>.el-tabs__content {
    height: calc(100% - 71px);
  }

  #pane-first{
   height:100%; overflow:auto;
  }
</style>



// WEBPACK FOOTER //
// src/view/visitor/Courses/Courseplay.vue